
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SAccContent extends Vue {
  // Les props
  @Prop({default: ''}) private title!: string
  @Prop({default: 0}) private nb!: number
  @Prop({default: 0}) private progress!: number
  @Prop({default: false}) private deleting!: boolean

  // Les propriétés
  // Les propriétés calculées
  private get percent() {
    return this.progress / this.nb * 100
  }
  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  // Les méthodes statiques
}
